module.exports = __webpack_public_path__ + "media/assets/images/flags/mh-8158e6d5025b41fbb9a76d9d7f43d39d.svg";